import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { CustomerProjectsTasksDataGrid } from '../../../components/datagrid/CustomerProjectsTasksDataGrid';
import { Task } from '../../../types/task.types';
import { isNilOrEmpty } from '../../../utils/ramdaUtils';
import { ITab, swrConfig } from '../../Assets/AssetsEdit';
import useSWR from 'swr';
import { API_URL, fetcher } from '../../../utils/apiUrl';
import { Loader } from '../../../components/loader/Loader';
import moment from 'moment';
import { MomentDateTimeSecondsSerializationFormat } from '../../../utils/dates.types';

interface Props extends ITab {
  id: string;
  customerId?: number;
  customerProjectId?: number;
  topLevelAssetId?: number;
  assetId?: number;
  filterData: CustomerProjectsTasksTabFilterData;
  setFilterData: (filterData: CustomerProjectsTasksTabFilterData) => void;  
}

export interface CustomerProjectsTasksTabFilterData {
  dateFrom?: string | null;
  dateTo?: string | null;
}

export const CustomerProjectsTasksTab = ({ id, active, customerId, customerProjectId, topLevelAssetId, assetId, filterData, setFilterData }: Props) => {
  const history = useHistory();


  const { data: tasks } = useSWR<Task[]>(
    `${API_URL.TASK_BY_CUSTOMER_PROJECT}?projectId=${id}${filterData.dateFrom ? `&filterFrom=${filterData.dateFrom}` : ''}${filterData.dateTo ? `&filterTo=${filterData.dateTo}` : ''}`, fetcher, swrConfig
  );

  const handleEditButton = (e): void => {
    if (!isNilOrEmpty(e.row) && !isNilOrEmpty(e.row.data)) {
      history.push(`/tasks/edit/${e.row.data.id}`);
    }
  };

  return (
    <>
      {tasks && <CustomerProjectsTasksDataGrid
        data={tasks}
        handleEdit={handleEditButton}
        customerId={customerId}
        customerProjectId={customerProjectId}
        topLevelAssetId={topLevelAssetId}
        assetId={assetId}
        filterData={filterData}
        onDateFromChanged={(dateFrom: string | null) => {
          setFilterData({ ...filterData, dateFrom: dateFrom ? moment(dateFrom).startOf('day').format(MomentDateTimeSecondsSerializationFormat) : null });
        }}
        onDateToChanged={(dateTo: string | null) => {
          setFilterData({ ...filterData, dateTo: dateTo ? moment(dateTo).endOf('day').format(MomentDateTimeSecondsSerializationFormat) : null });
        }}
      />}
    </>
  );
};
